import { createContext } from 'react';

/**
 * @internal
 * @deprecated
 */
var DeprecatedLayoutGroupContext = createContext(null);

export { DeprecatedLayoutGroupContext };
